import { uuidToColor } from '$lib/helper/color';
import type { Customer } from '$lib/model/booking';
import type { CustomerSearchPostApiResponse } from '$lib/types/api/customer';
import type { Axios } from 'axios';
import { DateTime } from 'luxon';
import { derived, get, writable } from 'svelte/store';
import { apiStore } from './api';
import { FormStatus, formStatus } from './form';
import { downloadData } from './navigation';
import type { Tag } from './tags';

export type CustomerStats = {
	totalCustomers: number;
	totalPhoneOptIn: number;
	totalEmailOptIn: number;
	averageSpent: number;
	averageBookings: number;
};

export const customerStore = writable<Customer[]>([]);
export const customerStatsStore = writable<CustomerStats>({
	totalCustomers: 0,
	totalPhoneOptIn: 0,
	totalEmailOptIn: 0,
	averageSpent: 0,
	averageBookings: 0
});

let timeout: NodeJS.Timeout;
export function autocomplete(search: string, callback: (customers: Customer[]) => void) {
	clearTimeout(timeout); // debounce
	if (search == '' || !search) {
		return;
	}

	timeout = setTimeout(
		() =>
			(get(apiStore) as Axios)
				.post<CustomerSearchPostApiResponse>('/customer/search', {
					search: search,
					limit: 5
				})
				.then((res) => {
					res.data.forEach((customer) => {
						customer.bookings.forEach((booking) => {
							booking.date = DateTime.fromISO(booking.date as unknown as string);
						});
					});
					callback(res.data);
				}),
		400
	);
}

export function newCustomer(): Customer {
	return {
		id: '',
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		phoneOptIn: true,
		emailOptIn: true,
		bookings: [],
		isVip: false,
		tags: [],
		firstBookingId: null,
		lastBookingId: null,
		totalSpent: 0,
		customFields: {}
	};
}

export const getCustomerColor = derived(
	[uuidToColor],
	([$uuidToColor]) =>
		(customer: Customer | undefined) => {
			if (!customer) return '';
			return $uuidToColor(customer.id);
		}
);

export function exportCustomer(params: {
	tags?: Tag[];
	optinSms?: boolean;
	optinEmail?: boolean;
	vip?: boolean;
	search?: string;
}) {
	formStatus.set(FormStatus.Processing);
	get(apiStore)
		?.post('/customer/export', params)
		.then((response) => {
			// Download the file
			downloadData(response.data, 'export.csv');
			formStatus.set(FormStatus.Success);
		})
		.catch(() => {
			formStatus.set(FormStatus.Error);
		});
}
